import { Button } from '@mui/material'
import { confirmEmail, resendEmailConfirmation } from 'api'
import ErrorMessage from 'components/atoms/ErrorMessage'
import OtpInput from 'components/atoms/OtpInput'
import useNavigatorOnLine from 'hooks/useNavigatorOnline'
import React, { useEffect, useRef, useState } from 'react'
import Countdown, { zeroPad } from 'react-countdown'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { subscriptionsActions } from 'store/reducers/subscriptions/subscriptions'
import { errorObj } from 'utils/handleError'
import { isAdminPage } from 'utils/isAdminPage'
import { showErrorMessage } from 'utils/showMessage'
import CircularProgress from '@mui/material/CircularProgress';
const VerifyEmailForm = ({ onNavigate }) => {
  const { t } = useTranslation();
  const token = useSelector((state) => state.subscriptions.registrationToken) || localStorage.getItem('registrationToken')
  const [registrationToken, setRegistrationToken] = useState('')
  const [loading, setLoading] = useState(false)

  const statusConnection = useNavigatorOnLine()
  const [otp, setOtp] = useState('')
  const navigate = useNavigate()
  const [errorOtp, setErrorOtp] = useState(null)
  const dispatch = useDispatch()


  const otpRef = useRef()
  const ref = useRef(Date.now())
  const [countdown, setCountdown] = useState({
    key: 1,
    show: true
  })
  const time = 60000
  const renderer = ({ minutes, seconds }) => {
    return (
      <span>
        {zeroPad(minutes)}:{zeroPad(seconds)}
      </span>
    )
  }
  function handleCompleteCountdown() {
    setCountdown((prev) => ({
      ...prev,
      show: false
    }))
  }

  const confirmOtp = useMutation({
    mutationKey: 'confirm-email',
    mutationFn: () => confirmEmail(otp, registrationToken),
    onSuccess: (res) => {
      setLoading(false)
      localStorage.setItem('registrationToken', res?.resData?.data?.access_token)
      dispatch(subscriptionsActions.setRegistrationToken(res?.resData?.data?.access_token))
      onNavigate()

    },
    onError: (err) => {
      setLoading(false)
      const errObj = errorObj(err)
    
      if (errObj.resStatus === 500) {
        setErrorOtp(isAdminPage() ? t('Wrong recovery code') : t('The code is invalid'))
      } 
    }
  })


  const resendCode = useMutation({
    mutationKey: 'resendEmailConfirmation',
    mutationFn: () => resendEmailConfirmation(registrationToken),
    onSuccess: (res) => {
      //console.log(res);
    },
    onError: (err) => {
      //console.log(err);
    }
  })

  const onChange = (value) => setOtp(value)

  const handleClickResend = () => {
    if (!statusConnection) return showErrorMessage(t('error messages.Internet connection error'))
    resendCode.mutate()
    ref.current = Date.now()
    setCountdown((prev) => ({
      key: prev + 1,
      show: true
    }))
  }

  useEffect(() => {
    // console.log('registrationToken',registrationToken);
    if (token && token?.length > 0) {
      localStorage.setItem('registrationToken', token)
      setRegistrationToken(token)
    } else {
      setRegistrationToken(localStorage.getItem('registrationToken'))
    }

  }, [token])



  return (
    <>
      {/* Typography */}

      <div className='mt-8'>

        <OtpInput isError={errorOtp} value={otp} valueLength={6} onChange={onChange} />
        <input
          ref={otpRef}
          className="hidden"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
        />
        {errorOtp ? <ErrorMessage className={'mt-2'} errorMessage={errorOtp} /> : null}
        {!isAdminPage() ? (
          <div className="flex justify-end items-center pt-2">

            {!countdown.show && (
              <span
                onClick={countdown.show ? () => { } : handleClickResend}
                className={`underline font-normal text-sm ${countdown.show ? 'text-[#828282] ' : 'text-[#0049EE] cursor-pointer'
                  }`}>
                {t('Resend code')}
              </span>
            )}



            {countdown.show ? (
              <span className="text-sm-medium text-gray-500">
                {t('Send new code in')}{' '}
                <Countdown
                  key={countdown.key}
                  date={ref.current + time}
                  zeroPadTime={2}
                  renderer={renderer}
                  onComplete={handleCompleteCountdown}
                />
              </span>
            ) : null}
          </div>
        ) : null}



        {/* Pulsanti */}
        <div className="mt-[58px] flex justify-end">
         {/*  <Button
            onClick={() => {
              //navigate('/sign-up')

              navigate(-1)
            }}
            type="button"
            variant="outlined"
            sx={{
              width: 124,
              borderColor: "#919191",
              fontSize: "16px",
              textTransform: "none",
              color: "#919191",
              paddingLeft: "22px",
              paddingRight: "22px",
              fontWeight: 600,
              marginRight: 2,
            }}
          >
            {t("Signup.Back")}
          </Button> */}

          <Button
            disabled={!otp || loading}
            onClick={() => {
              setLoading(true)
              confirmOtp.mutate()
            }}
            type="submit"
            variant="contained"

            sx={{
              width: loading ? 148 : 124,
              paddingLeft: "22px",
              paddingRight: "22px",
              fontWeight: 600,
              backgroundColor: "#0049EE",
              fontSize: "16px",
              textTransform: "none",
            }}
          >
            {t("Otp.Buy")}
            {loading && (<CircularProgress size="20px" style={{ marginLeft: 8, color: 'white' }} />)}
          </Button>
        </div>
      </div>
    </>
  )
}

export default VerifyEmailForm
